import React from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { Checkbox, Dropdown, Input, Radio, TextArea } from "semantic-ui-react";
import { hoverDroppableAtom } from "../../setup/atom/Atom";
import { useAtom } from "jotai";

export const DraggableItem = ({ item, index }) => {
  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            ...provided.draggableProps.style,
          }}
          className={item.class}
        >
          {item.content}
        </div>
      )}
    </Draggable>
  );
};

export const DroppableContainer = ({
  droppableId,
  children,
  className = "",
  direction = "vertical",
  style = {},
  onClick = () => {},
}) => {
  const [hoverDroppableId] = useAtom(hoverDroppableAtom);
  return (
    <Droppable droppableId={droppableId} direction={direction}>
      {(provided) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          className={`${className} ${
            hoverDroppableId === droppableId ? "droppable-hover" : ""
          }`}
          style={{ ...style }}
          onClick={(e) => onClick(e)}
        >
          {children}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export const getInputField = (info) => {
  const {
    type,
    display_name,
    active,
    editable,
    everyone,
    mandatory,
    size_from,
    size_to,
  } = info;
  let inputField;

  switch (type) {
    case "Text Field" || "text":
      inputField = (
        <Input
          type="text"
          placeholder={display_name}
          minLength={size_from ? size_from : ""}
          maxLength={size_to ? size_to : ""}
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;

    case "Text Area":
      inputField = (
        <TextArea
          rows="4"
          cols="50"
          placeholder={display_name}
          minLength={size_from ? size_from : ""}
          maxLength={size_to ? size_to : ""}
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;

    case "Number":
      inputField = (
        <Input
          type="number"
          placeholder={display_name}
          minLength={size_from ? size_from : ""}
          maxLength={size_to ? size_to : ""}
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;

    case "Date":
      inputField = (
        <Input type="date" {...(mandatory ? { required: true } : {})} />
      );
      break;

    case "Dropdown":
      inputField = (
        <Dropdown
          search
          selection
          options={[]}
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;

    case "Multiple Selection":
      inputField = (
        <Dropdown
          multiple
          search
          selection
          options={[]}
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;

    case "Radio Group":
      inputField = (
        <Radio
          label="Option 1"
          name="radioGroup"
          value="option1"
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;

    case "Checkbox":
      inputField = (
        <Checkbox
          label={display_name}
          {...(mandatory ? { required: true } : {})}
        />
      );
      break;
  }

  return inputField;
};
